module.exports = __webpack_public_path__ + "img/Digital-Cubed-logo.f1ed4340.png";